import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitContentTypo.module.scss';

const Typo = forwardRef(
  (
    { className, color = 'primary', element, modifier, noWrap, testId, variant, weight, ...other },
    ref,
  ) => {
    if (!element) return null;

    const DEPRECATED_VARIANTS = {
      heading1: styles.isVariantDisplay07,
      heading2: styles.isVariantDisplay07,
      heading3: styles.isVariantDisplay06,
      heading4: styles.isVariantDisplay03,
      heading5: styles.isVariantDisplay01,
      heading6: styles.isVariantBody02,
      heading7: styles.isVariantBody01,
      body1: styles.isVariantBody03,
      body2: styles.isVariantBody02,
      body3: styles.isVariantBody01,
      label1: styles.isVariantBody01,
      label2: styles.isVariantSupport01,
      label3: styles.isVariantSupport01,
    };

    const VARIANTS = {
      ...DEPRECATED_VARIANTS,
      h1: styles.isVariantDisplay07,
      d07: styles.isVariantDisplay07,
      h2: styles.isVariantDisplay06,
      d06: styles.isVariantDisplay06,
      h3: styles.isVariantDisplay05,
      d05: styles.isVariantDisplay05,
      h4: styles.isVariantDisplay04,
      d04: styles.isVariantDisplay04,
      d03: styles.isVariantDisplay03,
      d02: styles.isVariantDisplay02,
      h5: styles.isVariantDisplay01,
      d01: styles.isVariantDisplay01,
      b03: styles.isVariantBody03,
      h6: styles.isVariantBody02,
      p: styles.isVariantBody02,
      span: styles.isVariantBody02,
      b02: styles.isVariantBody02,
      b01: styles.isVariantBody01,
      s03: styles.isVariantSupport03,
      s02: styles.isVariantSupport02,
      s01: styles.isVariantSupport01,
      c01: styles.isVariantCode01,
    };

    const WEIGHTS = {
      medium: styles.isModifierMedium,
      bold: styles.isModifierBold,
    };

    const MODIFIERS = {
      italic: styles.isModifierItalic,
      uppercase: styles.isModifierCaps,
    };

    const COLORS = {
      primary: styles.isColorPrimary,
      secondary: styles.isColorSecondary,
      brand: styles.isColorBrand,
      negative: styles.isColorNegative,
    };

    const Element = element;
    const variantIdentifier = variant || element;

    if (DEPRECATED_VARIANTS.hasOwnProperty(variant)) {
      console.warn(`${variant} is deprecated, please use one of the supported variants.`);
    }

    return (
      <Element
        className={classnames(
          styles.element,
          {
            [VARIANTS[variantIdentifier]]: variantIdentifier,
            [WEIGHTS[weight]]: weight,
            [MODIFIERS[modifier]]: modifier,
            [COLORS[color]]: color,
            [styles.noWrap]: noWrap,
          },
          className,
        )}
        data-testid={testId}
        ref={ref}
        {...other}
      />
    );
  },
);

Typo.displayName = 'Typo';

Typo.defaultProps = {
  className: '',
  color: 'primary',
  element: 'p',
  modifier: '',
  noWrap: false,
  testId: '',
  variant: '',
  weight: '',
};

Typo.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'secondary', 'brand', 'negative']),
  element: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'span', 'div']),
  modifier: PropTypes.string,
  noWrap: PropTypes.bool,
  testId: PropTypes.string,
  variant: PropTypes.string,
  weight: PropTypes.string,
};

export default React.memo(Typo);
